import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataYAxisTitleValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                text: {
                    type: 'string',
                    empty: false,
                    mandatory: false
                }
            }
        };
    }
}
